export default __webpack_public_path__ + "static/media/level-2-bg.e97f1d39.png";